import useAnalytics from "@/hooks/useAnalytics";
import useTranslation from "@/hooks/useTranslation";
import { useDeleteEpd } from "@/pages/impact_references/epd/useEpd";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { Popconfirm, message } from "antd";
import { ReactNode } from "react";

export default function DeleteEpdAction({
  children,
  id,
  onSuccess,
}: {
  children: ReactNode;
  id?: number;
  onSuccess?: () => void;
}) {
  const deleteEpd = useDeleteEpd();
  const translation = useTranslation();
  const analytics = useAnalytics();

  return (
    <Popconfirm
      title={`Delete EPD`}
      description={
        <>
          <p>Deleting can cause the following:</p>
          <ul>
            <li>materials that use this EPD, need a new impact reference</li>
            <li>the impact calculation will be affected if there is a reference missing</li>
          </ul>
          <p style={{ color: "#F5222D" }}>This action can not be undone.</p>
        </>
      }
      onConfirm={() =>
        deleteEpd
          .mutateAsync({ id })
          .then((result) => {
            if (result.status === 200) {
              message.success(`EPD successfully removed.`);
              analytics.track("EPD Deleted");
              onSuccess && onSuccess();
            }
          })
          .catch(() => message.error(translation.errors.general))
      }
      onCancel={() => {}}
      icon={<ExclamationCircleFilled style={{ color: "#F5222D" }} />}
      okText={`Delete EPD`}
      cancelText="Cancel"
      placement="bottom"
      okType="danger"
      okButtonProps={{ loading: deleteEpd.isLoading }}
    >
      {children}
    </Popconfirm>
  );
}
